module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "community-content"
  }, [(_vm.toggleSpinner) ? _c('spinner', {
    staticClass: "pink",
    attrs: {
      "size": "lg",
      "fixed": "",
      "text": "refreshing event"
    },
    model: {
      value: (_vm.toggleSpinner),
      callback: function($$v) {
        _vm.toggleSpinner = $$v
      },
      expression: "toggleSpinner"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('i', {
    staticClass: "fa fa-5x fa-calendar",
    style: ({
      color: _vm.getCorpHeaderColor
    })
  }), _vm._v(" "), _c('h2', {
    style: ({
      color: _vm.getCorpHeadingColor,
      textTransform: 'unset !important'
    })
  }, [_vm._v(_vm._s(_vm.pageTitle) + "\n                "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.pageDesc))])]), _vm._v(" "), (_vm.getMainEvent && _vm.showRulesComp && _vm.showJoin(_vm.getMainEvent.eventId)) ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.getMainEvent) ? _c('rulescomp', {
    style: ({
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpHeaderColor + ' !important'
    }),
    attrs: {
      "data": _vm.getMainEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.getMainEvent) ? _c('div', {
    staticClass: "communityBox"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getMainEvent) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [(_vm.currentVideo) ? _c('jwplayer', {
    attrs: {
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")]) : _vm._e(), _vm._v(" "), (!_vm.currentVideo) ? _c('img', {
    attrs: {
      "src": _vm.getMainEvent.img_url,
      "alt": "MAIN EVENT BANNER",
      "title": _vm.getMainEvent.title
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.getMainEvent) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('h2', {
    style: ({
      color: _vm.getCorpButtonColor + ' !important'
    })
  }, [(_vm.getMainEvent.type === '1') ? _c('span', [_vm._v("TONE Live")]) : _c('span', [_vm._v(_vm._s(_vm.getMainEvent.title))])]), _vm._v(" "), (_vm.getMainEvent) ? _c('p', [_vm._v("\n                            " + _vm._s(_vm.getMainEvent.longDescription) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.getDateReference(_vm.getMainEvent.start_date, 'str')) + "\n                        ")]), _vm._v(" "), (!_vm.showJoin(_vm.getMainEvent.eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.getMainEvent.title)
      }
    }
  }, [_vm._v("\n                            Add to Calendar\n                            "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getMainEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.getMainEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getMainEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getMainEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.getMainEvent.type === '1') ? _c('span', [_vm._v(_vm._s(_vm.buildEventLink(_vm.getMainEvent.eventId)))]) : _c('span', [_vm._v(_vm._s(_vm.buildEventLink(_vm.getMainEvent.eventId)))])])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.getMainEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                        ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.getMainEvent && _vm.showRulesComp && !_vm.showJoin(_vm.getMainEvent.eventId)) ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.getMainEvent) ? _c('rulescomp', {
    style: ({
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpHeaderColor + ' !important'
    }),
    attrs: {
      "data": _vm.getMainEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sliderEventBox"
  }, [_c('h2', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(_vm._s(_vm.liveHeading))]), _vm._v(" "), _c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.getEventList), function(ev) {
    return (ev.eventId !== _vm.getMainEvent.eventId) ? _c('div', {
      staticClass: "col-sm-4"
    }, [_c('h2', {
      staticClass: "carosalh2",
      style: ({
        color: _vm.getCorpButtonColor + ' !important'
      })
    }, [(ev.type === '1') ? _c('span', [_vm._v("TONE Live\n")]) : _c('span', [_vm._v(" " + _vm._s(ev.title))])]), _vm._v(" "), _c('img', {
      attrs: {
        "src": ev.img_url,
        "alt": "EVENT BANNER",
        "title": ev.title
      }
    }), _vm._v(" "), _c('h2', [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor + ' !important'
      }),
      attrs: {
        "href": '/event/' + ev.eventId,
        "target": "new"
      }
    }, [_vm._v(_vm._s(_vm.getDateReference(ev.start_date, 'live')) + " with " + _vm._s(_vm.replaceLastExpert(ev.csvExpertsNames, ',', ' & ')))])]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(ev.longDescription) + "\n                        ")]), _vm._v(" "), _c('h5', [_vm._v("LIVE " + _vm._s(_vm.getDateReference(ev.start_date, 'live2')) + " ")]), _vm._v(" "), (!_vm.showJoin(ev.eventId)) ? _c('div', {
      staticClass: "addeventatc pinkoutlinebtn",
      style: ({
        color: _vm.getCorpButtonColor + ' !important',
        border: '1px solid ' + _vm.getCorpButtonColor
      }),
      attrs: {
        "title": "Add to Calendar"
      },
      on: {
        "click": function($event) {
          return _vm.calendarLogging($event, ev.title)
        }
      }
    }, [_vm._v("\n                            Add to Calendar\n                            "), _c('span', {
      staticClass: "start"
    }, [_vm._v(_vm._s(ev.start_date))]), _vm._v(" "), _c('span', {
      staticClass: "end"
    }, [_vm._v(_vm._s(ev.end_date))]), _vm._v(" "), _c('span', {
      staticClass: "timezone"
    }, [_vm._v("ev/New_York")]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(ev.title))]), _vm._v(" "), _c('span', {
      staticClass: "description"
    }, [_vm._v(_vm._s(ev.longDescription))]), _vm._v(" "), _c('span', {
      staticClass: "location"
    }, [_vm._v(_vm._s(_vm.buildEventLink(ev.eventId)))])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
      staticClass: "share-event",
      style: ({
        color: _vm.getCorpButtonColor + ' !important',
        borderWidth: '1px !important',
        borderStyle: 'solid !important',
        borderColor: _vm.getCorpButtonColor + ' !important'
      }),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openCorporateImageShareModal(ev)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-share-square-o"
    }), _vm._v(" Share\n                        ")]) : _vm._e()]) : _vm._e()
  }), 0)]), _vm._v(" "), (_vm.getLiveEventsArchive) ? _c('div', {
    staticClass: "sliderEventBox pointer",
    attrs: {
      "id": "missed"
    }
  }, [_c('h2', {
    staticClass: "archive-less-spacing",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(_vm._s(_vm.archiveHeading))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.archiveDesc))]), _vm._v(" "), _c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.getLiveEventsArchive), function(evn) {
    return _c('div', {
      staticClass: "col-sm-4",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('div', {
      staticClass: "show-share-options",
      style: ({
        backgroundColor: _vm.getCorpHeadingColor
      })
    }, [_c('img', {
      attrs: {
        "src": evn.img_url,
        "alt": "ARCHIVE EVENT BANNER",
        "title": evn.title
      },
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }), _c('div', {
      staticClass: "favnumbers",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('div', [_c('span', [_vm._v(_vm._s(evn.allVidDurInMinutes)), _c('small', [_vm._v("mins")])])]), _c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "title": "Play"
      },
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }), (((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.shareEventCoachingTipPermission >= 1))) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "Share Playlist"
      },
      on: {
        "click": function($event) {
          return _vm.showSharingModal(evn)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('h2', {
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }, [_vm._v(_vm._s(evn.title))]), _vm._v(" "), _c('p', {
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(evn.longDescription) + "\n                        ")])])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.showSharedModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showSharedModal
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelEmailShareModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg"),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelEmailShareModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "method": "post",
      "id": "playlistshare-form",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSharePlaylist.apply(null, arguments)
      }
    }
  }, [_c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "name": "playlistshare_sharedMessage",
      "id": "playlistshare_sharedMessage",
      "type": "text",
      "error": "Optional Message",
      "placeholder": "Optional Message",
      "autocomplete": "off",
      "icon": ""
    },
    model: {
      value: (_vm.sharePayload.sharedEmailMessage),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedEmailMessage", $$v)
      },
      expression: "sharePayload.sharedEmailMessage"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "name": "playlistshare_sharedEmailMessagePreview",
      "id": "playlistshare_sharedEmailMessagePreview",
      "type": "textarea",
      "disabled": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.sharePayload.sharedPlaylistPreview),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedPlaylistPreview", $$v)
      },
      expression: "sharePayload.sharedPlaylistPreview"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "disabled": _vm.spinner || (_vm.taggedEmails && _vm.taggedEmails.length === 0)
    }
  }, [_vm._v("\n                            Send Email\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_vm._v("\n                Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.showShareCommunity) ? _c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]) : _vm._e(), _vm._v(" "), (_vm.showShareIndividual) ? _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]) : _vm._e(), _vm._v(" "), (_vm.showShareFriends) ? _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")]) : _vm._e()])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.corpShareModalImage,
      "alt": _vm.corpShareModalTitle,
      "title": _vm.corpShareModalTitle
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s((_vm.corpShareModalTitle + " | TONE Networks")))]), _vm._v(" "), (_vm.corpShareModalDesc) ? _c('p', [_vm._v(" " + _vm._s(((_vm.corpShareModalDesc.substring(0,250)) + "...")))]) : _vm._e(), _vm._v(" "), (!_vm.corpShareModalDesc) ? _c('p', [_vm._v(_vm._s(_vm.user.firstName) + "'s Personal Playlist")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess)) || (_vm.shareInProcess)
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateVideo()
      }
    }
  }, [_vm._v("\n                            Share This Playlist\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateImageShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateImageShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")])])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.shareEventSelected.img_url,
      "alt": _vm.shareEventSelected.title,
      "title": _vm.shareEventSelected.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(((_vm.shareEventSelected.title) + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.shareEventSelected.longDescription.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateImage()
      }
    }
  }, [_vm._v("\n                            Share This Event\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fc8db22c", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc8db22c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Community.vue